import React from "react";
import { FEATURES_CONFIG } from "../../../featuresConfig";
import SceneTransitionOverlay from "../SceneTransitionOverlay/SceneTransitionOverlay";
import RoyalCollectSceneTransition from "../RoyalCollect/RoyalCollectSceneTransition/RoyalCollectSceneTransition";

const Transitions = () => {
  return (
    <>
      {FEATURES_CONFIG.HOLD_AND_WIN.ENABLED && <SceneTransitionOverlay />}
      {FEATURES_CONFIG.ROYAL_COLLECT.ENABLED && <RoyalCollectSceneTransition />}
    </>
  );
};

export default Transitions;
